import { Box, Button, Grid, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import AgentTable from "../../components/agentComponent/AgentTable";
import CreateAgent from "../../components/agentComponent/agentCreation/CreateAgent";
import { Routes, Route, useNavigate, Outlet } from "react-router-dom";
import AgentDetails from "../../components/agentComponent/agentDetails";

function Agent() {
  const navigate = useNavigate();
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
          <Box height={65} />
          <Box>
            <Typography variant="h4">Agents</Typography>
          </Box>

          <Box mt={1}>
            {/* Nested Routes will be rendered here */}
            <Routes>
              <Route path="/" element={<AgentTable />} />
              <Route path="create-Agent" element={<CreateAgent />} />
              <Route path="/:id" element={<AgentDetails />} />
            </Routes>
          </Box>
        </Box>
      </Box>
      {/* Outlet is used for rendering nested routes if further nesting is needed */}
      <Outlet />
    </div>
  );
}

export default Agent;
